import React, { useState, useEffect } from 'react';
import { Box, Button, Typography, Tabs, Tab } from '@mui/material';
import { headingBlue, mediumGrey, pureWhite } from '../../../assets/colors';
import TrainingProgramTable from './TrainingProgramTable';
import AddProgramDialog from './AddProgramDialog';


import { fetchTrainingProgram, fetchTrainingBatches, fetchTrainingClasses } from '../../../backend/backendApis';
import HttpService from '../../../backend/requestApis';
import { useDispatch } from 'react-redux';
import { showSnackBar } from '../../CustomComponents/CustomComponentsSlice';
import { useNavigate } from 'react-router-dom';
import AddBatchDialog from '../Batch/AddBatchDialog';
import TrainingBatchTable from '../Batch/TrainingBatchTable';
import TrainingClassesTable from '../Classes/TrainingClassesTable';


function TabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      {...other}
    >
      {value === index && (
        <Box style={{ padding: '0rem', backgroundColor: pureWhite, borderRadius: '0.5rem', marginTop: '1rem' }}>
          {children}
        </Box>
      )}
    </div>
  );
}

const TrainingProgram = () => {
  const [tabValue, setTabValue] = useState(0);
  const [designation, setDesignation] = useState("");
  const [addProgramDialogStatus, setAddProgramDialogStatus] = useState(false);
  const [addBatchDialogStatus, setAddBatchDialogStatus] = useState(false);
  const dispatch = useDispatch();
  const navigate = useNavigate();
  
  const [page, setPage] = useState(1);
  const [offset, setOffset] = useState(15);
  const [filterBy, setFilterBy] = useState('');
  const [isLoading, setIsLoading] = useState(false);
  const [refreshtable, setRefreshTable] = useState(false);
  const [tableData, setTableData] = useState([]);

  // Pagination & Filtering state specifically for Training Batch
  const [batchPage, setBatchPage] = useState(1);
  const [batchOffset, setBatchOffset] = useState(15);
  const [batchFilterBy, setBatchFilterBy] = useState('');
  const [batchTableData, setBatchTableData] = useState({data: [], totalRecords: 0, totalPages: 1});
  const [isBatchLoading, setIsBatchLoading] = useState(false);
  const [refreshBatchTable, setRefreshBatchTable] = useState(false);

  // Pagination & Filtering state specifically for Training Classes
  const [classPage, setClassPage] = useState(1);
  const [classOffset, setClassOffset] = useState(15);
  const [classFilterBy, setClassFilterBy] = useState('');
  const [classTableData, setClassTableData] = useState({data: [], totalRecords: 0, totalPages: 1});
  const [isClassLoading, setIsClassLoading] = useState(false);
  const [refreshClassTable, setRefreshClassTable] = useState(false);
  const [classAdvancedFilters, setClassAdvancedFilters] = useState({
    status: 'All',
    program: '',
    batch: '',
    coordinator: ''
  });

  const updatePage = (value) => {
    setPage(() => value);
    setRefreshTable(() => !refreshtable);
  };

  const updateBatchPage = (value) => {
    setBatchPage(() => value);
    setRefreshBatchTable((prev) => !prev);
  };

  const updateBatchOffset = (value) => {
    setBatchOffset(() => value);
    setBatchPage(1);
    setRefreshBatchTable((prev) => !prev);
  };

  const updateClassPage = (value) => {
    setClassPage(() => value);
    setRefreshClassTable((prev) => !prev);
  };

  const updateClassOffset = (value) => {
    setClassOffset(() => value);
    setClassPage(1);
    setRefreshClassTable((prev) => !prev);
  };

  useEffect(() => {
    const delayDebounceFn = setTimeout(() => {
      setRefreshBatchTable((prev) => !prev);
    }, 500);
    return () => clearTimeout(delayDebounceFn);
  }, [batchFilterBy]);

  useEffect(() => {
    const delayDebounceFn = setTimeout(() => {
      setClassPage(1);
      setRefreshClassTable((prev) => !prev);
    }, 500);
    return () => clearTimeout(delayDebounceFn);
  }, [classFilterBy, classAdvancedFilters.status, classAdvancedFilters.program, classAdvancedFilters.batch, classAdvancedFilters.coordinator]);

  const updateOffset = (value) => {
    setOffset(() => value);
    setRefreshTable(() => !refreshtable);
  };

  const updateAddProgramDialogStatus = (value, refresh= false) => {
    setAddProgramDialogStatus(() => value);
    if( refresh){
      setRefreshTable(() => !refreshtable);
    }
  };

  const updateAddBatchDialogStatus = (value, refresh= false) => {
    setAddBatchDialogStatus(() => value);
    if(refresh) {
      setRefreshBatchTable((prev) => !prev);
    }
  };


  useEffect(() => {
    if (tabValue === 2) { // Fetch table data when Programs tab is active
      setIsLoading(() => true);
      let options = {
        url: fetchTrainingProgram,
        method: 'GET',
        params: {
          page: page,
          offset: offset
        },
        headers: {
          Authorization: localStorage.getItem('token') ? `Bearer ${localStorage.getItem('token')}` : null
        }
      };

      HttpService(options).then((resp) => {
        setTableData(() => resp?.data?.data);
        setIsLoading(() => false);
      }).catch(err => {
        if (err?.status === 403) {
          localStorage.clear();
          setIsLoading(false);
          navigate('/login');
        } else {
          console.log('Error in fetching Table Data: ', err);
          setIsLoading(() => false);
          dispatch(showSnackBar({message: 'Error in fetching Table Data. Please Contact Support.', severity: 'error'}));
        }
      });
    }
  }, [refreshtable, tabValue]);

  useEffect(() => {
    if (tabValue === 1) { // Fetch table data when Batches tab is active
      setIsBatchLoading(true);
      let options = {
        url: fetchTrainingBatches,
        method: 'GET',
        params: {
          page: batchPage,
          offset: batchOffset,
          search: batchFilterBy
        },
        headers: {
          Authorization: localStorage.getItem('token') ? `Bearer ${localStorage.getItem('token')}` : null
        }
      };

      HttpService(options).then((resp) => {
        let resData = resp?.data?.data;
        setBatchTableData({
          data: resData?.data || [],
          totalRecords: resData?.total_count || 0,
          totalPages: resData?.total_pages || 1
        });
        setIsBatchLoading(false);
      }).catch(err => {
        if (err?.status === 403) {
          localStorage.clear();
          setIsBatchLoading(false);
          navigate('/login');
        } else {
          console.log('Error in fetching Batch Table Data: ', err);
          setIsBatchLoading(false);
          dispatch(showSnackBar({message: 'Error in fetching Batch Table Data. Please Contact Support.', severity: 'error'}));
        }
      });
    }
  }, [refreshBatchTable, tabValue]);

  useEffect(() => {
    if (tabValue === 0) { // Fetch table data when Classes tab is active
      setIsClassLoading(true);
      let options = {
        url: fetchTrainingClasses,
        method: 'GET',
        params: {
          page: classPage,
          offset: classOffset,
          search: classFilterBy,
          status: classAdvancedFilters.status !== 'All' ? classAdvancedFilters.status : undefined,
          program: classAdvancedFilters.program || undefined,
          batch: classAdvancedFilters.batch || undefined,
          coordinator: classAdvancedFilters.coordinator || undefined
        },
        headers: {
          Authorization: localStorage.getItem('token') ? `Bearer ${localStorage.getItem('token')}` : null
        }
      };

      HttpService(options).then((resp) => {
        let resData = resp?.data?.data;
        setClassTableData({
          data: resData?.data || [],
          totalRecords: resData?.total_count || 0,
          totalPages: resData?.total_pages || 1
        });
        setIsClassLoading(false);
      }).catch(err => {
        if (err?.status === 403) {
          localStorage.clear();
          setIsClassLoading(false);
          navigate('/login');
        } else {
          console.log('Error in fetching Classes Table Data: ', err);
          setIsClassLoading(false);
          dispatch(showSnackBar({message: 'Error in fetching Classes Table Data. Please Contact Support.', severity: 'error'}));
        }
      });
    }
  }, [refreshClassTable, tabValue]);

  useEffect(() => {
    const userDesignation = localStorage.getItem("designation");
    setDesignation(userDesignation);
  }, []);

  const handleTabChange = (event, newValue) => {
    setTabValue(newValue);
    // Force a fetch on landing of the corresponding tab
    if (newValue === 0) {
      setClassPage(1); 
      setRefreshClassTable((prev) => !prev);
    } else if (newValue === 1) {
      setBatchPage(1); // Optional: reset to first page when returning to the tab
      setRefreshBatchTable((prev) => !prev);
    } else if (newValue === 2) {
      setPage(1); 
      setRefreshTable((prev) => !prev);
    }
  };

  return (
    <>
      <Box sx={{ borderBottom: 1, borderColor: 'divider', display: 'flex', justifyContent: 'space-between', alignItems: 'center', px: 3, backgroundColor: pureWhite }}>
        <Tabs 
          value={tabValue} 
          onChange={handleTabChange} 
          TabIndicatorProps={{ style: { backgroundColor: headingBlue, height: '4px', borderRadius: '4px 4px 0 0' } }}
          sx={{ 
            '& .MuiTab-root': { 
              fontSize: '1rem', 
              textTransform: 'none', 
              fontWeight: 600, 
              color: '#888', 
              padding: '0.8rem 2rem',
              minHeight: '4rem',
              transition: '0.3s ease',
            },
            '& .MuiTab-root:hover': {
              color: headingBlue,
              backgroundColor: 'rgba(0, 0, 0, 0.02)',
            },
            '& .Mui-selected': { color: `${headingBlue} !important` }
          }}
        >
          <Tab label="Classes" />
          <Tab label="Batches" />
          <Tab label="Programs" />
        </Tabs>
        <Box style={{ display: 'flex', gap: '0.5rem' }}>
          {designation === 'admin' && tabValue === 1 && (
            <Button 
              variant="outlined" 
              style={{ backgroundColor: headingBlue, color: pureWhite, textTransform: 'capitalize', fontFamily: 'Helvetica', fontWeight: '300', fontSize: '0.9rem', padding: '0.3rem 1.5rem' }}
              onClick={() => setAddBatchDialogStatus(true)}
            >
              Add Training Batch
            </Button>
          )}
          {designation === 'admin' && tabValue === 2 && (
            <Button 
              variant="outlined" 
              style={{ backgroundColor: headingBlue, color: pureWhite, textTransform: 'capitalize', fontFamily: 'Helvetica', fontWeight: '300', fontSize: '0.9rem', padding: '0.3rem 1.5rem' }}
              onClick={() => setAddProgramDialogStatus(true)}
            >
              Add Program
            </Button>
          )}
        </Box>
      </Box>
      <Box style={{ 
        overflow: 'auto', 
        padding: "0.3rem 1.5rem 0rem 1.5rem"
      }}>
        <TabPanel value={tabValue} index={0}>
          <TrainingClassesTable
            data={classTableData}
            isLoading={isClassLoading}
            pageValue={classPage}
            offsetValue={classOffset}
            updatePage={updateClassPage}
            updateOffset={updateClassOffset}
            filterByValue={classFilterBy}
            updateFilterBy={setClassFilterBy}
            advancedFilters={classAdvancedFilters}
            updateAdvancedFilters={setClassAdvancedFilters}
          />
        </TabPanel>
        <TabPanel value={tabValue} index={1}>
          <TrainingBatchTable
            data={batchTableData}
            isLoading={isBatchLoading}
            pageValue={batchPage}
            offsetValue={batchOffset}
            updatePage={updateBatchPage}
            updateOffset={updateBatchOffset}
            filterByValue={batchFilterBy}
            updateFilterBy={setBatchFilterBy}
          />
        </TabPanel>
        <TabPanel value={tabValue} index={2}>
          <TrainingProgramTable
            data={tableData}
            isLoading={isLoading}
            pageValue={page}
            offsetValue={offset}
            updatePage={updatePage}
            updateOffset={updateOffset}
            filterByValue={filterBy}
            updateFilterBy={setFilterBy}
          />
        </TabPanel>
      </Box>
      <AddProgramDialog dialogStatus={addProgramDialogStatus} updateFunc={updateAddProgramDialogStatus} />
      <AddBatchDialog dialogStatus={addBatchDialogStatus} updateFunc={updateAddBatchDialogStatus} />
    </>
  );
};

export default TrainingProgram;
